import React from 'react';
import img from '../../assets/dashboard.png';
import styles from './index.module.css';
import {
  IoGitNetworkOutline,
  IoSwapHorizontalOutline,
  IoStatsChartOutline,
  IoSearchOutline,
  IoTrendingUpOutline,
} from 'react-icons/io5';

const FEATURE_ITEMS = [
  {
    icon: IoGitNetworkOutline,
    title: 'Understand how your customers shop',
    description:
      'Get insights into how, when, and where each item or category is selling with detailed sales reports.',
  },
  {
    icon: IoSwapHorizontalOutline,
    title: 'Monitor inventory costs',
    description:
      'Stay on top of costs and profitability with built-in cost of goods sold (COGS) tracking.',
  },
  {
    icon: IoStatsChartOutline,
    title: 'Track inventory sell-through',
    description:
      'See how inventory moves relative to sales, helping you make smarter purchasing decisions.',
  },
  {
    icon: IoSearchOutline,
    title: 'Spot slow-moving stock',
    description:
      'Identify ageing inventory so you can adjust pricing, optimise turnover and free up cash flow.',
  },
  {
    icon: IoTrendingUpOutline,
    title: 'Predict the revenue of your inventory',
    description:
      'Track the projected profit you could make and value of your inventory across different stores for smarter planning.',
  },
];

const KPI_ITEMS = [
  {
    value: "40%",
    title: "Faster Checkout",
    subtitle: "Speed up service",
  },
  {
    value: "30%",
    title: "Less Manual Work",
    subtitle: "Automate tasks",
  },
  {
    value: "24/7",
    title: "Cloud Access",
    subtitle: "Access anywhere",
  },
  {
    value: "99.9%",
    title: "System Uptime",
    subtitle: "Reliable & secure",
  },
];

const PosViewSection = () => {
  return (
    <div className={styles.container}>
      <div className={styles.innerDiv}>
        <div className={styles.leftDiv}>
          <h2 className={styles.titleDiv}>
            Know what&apos;s selling and why
          </h2>
          <p className={styles.descriptionDiv}>
          Access it online anytime, anywhere, and keep every branch connected in one place. From monitoring performance to managing operations, handle it all with just a few clicks. Stay in control, simplify workflows, and focus on growth, not on switching between systems.
Smart, simple, and powerful. Track performance, streamline workflows, and make faster decisions with intuitive tools designed for all users. From daily transactions to advanced analytics, the dashboard adapts to your needs so you can focus on what truly matters: growing your business and serving your customers.
          </p>
        </div>
        <div className={styles.rightDiv}>
          <img className={styles.posImage} src={img} alt="" loading="lazy" />
        </div>
      </div>
      <div className={styles.featureSection}>
        {FEATURE_ITEMS.map(({ icon: Icon, title, description }) => (
          <div className={styles.featureCard} key={title}>
            <Icon className={styles.featureIcon} aria-hidden="true" />
            <h3 className={styles.featureTitle}>{title}</h3>
            <p className={styles.featureDescription}>{description}</p>
          </div>
        ))}
      </div>
      <div className={styles.kpiBar}>
        {KPI_ITEMS.map(({ value, title, subtitle }) => (
          <div className={styles.kpiItem} key={title}>
            <div className={styles.kpiValue}>{value}</div>
            <div className={styles.kpiTitle}>{title}</div>
            <div className={styles.kpiSubtitle}>{subtitle}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PosViewSection;
